import type { AccessPair } from '@/shared/lib'

/**
 * `GET /v1/catalog/supplier-prices` — мегапоиск по прайсам поставщиков. Право `catalog.megasearch`
 * (клиент с расширенным доступом и менеджер). Ручка не принимает модификатор «от имени»
 * (`onBehalf` нет): `?client=` она отвергает `400`.
 */
export const SUPPLIER_PRICES_ACCESS: AccessPair = { own: 'catalog.megasearch' }
